import React from 'react';
import { X } from 'lucide-react';
// Reuse the same CSS file 4646

const InstanceMessageTemplateWelcome = ({ onClose, onUse, onCancel }) => {
  const templateContent = `Welcome to our platform, {{client_name}}! 🎉

We're excited to have you on board. Our team is here to help you with all your {{service_type}} needs.

Your dedicated account manager is {{manager_name}}, who will be your primary point of contact.

Let's get started!

Cheers,
{{your_name}}`;

  const handleUseTemplate = () => {
    if (onUse) {
      onUse(templateContent);
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div className="instance-message-modal-overlay">
      <div className="instance-message-template-welcome">
        {/* Header */}
        <div className="instance-message-template-header">
          <div className="instance-message-template-title-wrapper">
            <h3 className="instance-message-template-title">Welcome Message</h3>
            <p className="instance-message-template-category">Client Onboarding • Welcome</p>
          </div>
          
          {/* Close Button */}
          <button 
            className="instance-message-template-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            <X className="instance-message-template-close-icon" />
          </button>
        </div>

        {/* Template Content Preview */}
        <div className="instance-message-template-preview">
          <pre className="instance-message-template-content">
            {templateContent}
          </pre>
        </div>

        {/* Action Buttons */}
        <div className="instance-message-template-actions">
          <button 
            className="instance-message-template-use-btn"
            onClick={handleUseTemplate}
          >
            Use Template
          </button>
          
          <button 
            className="instance-message-template-cancel-btn"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstanceMessageTemplateWelcome;